module.exports = __webpack_public_path__ + "static/media/reversecover-1.7717b583.png";